module.exports = __webpack_public_path__ + "img/title.a02f44cf.png";